common.View.create('website::layouts.Main', {

    onDOMLoad()
    {
        this.initDropdownMenu();
    },

    initDropdownMenu() {
        $('ul li.nav-item').hover((event) => {
            console.log(event);
            if($(event.currentTarget).find('> .dropdown-toggle').length) {
                $('.website\\:\\:layouts-main-Header a.logo img').attr('src', '/img/website/logo.svg');
            }
        }, (event) => {
            $('.website\\:\\:layouts-main-Header a.logo img').attr('src', '/img/website/logo_white.svg');
        });
    },
});
